import React from "react";
import useContexto from "~/fetchs/useContexto";
import useFunilObraGrupoProduto from "~/fetchs/useFunilObraGrupoProduto";
import useFunilObraProduto from "~/fetchs/useFunilObraProduto";
import useMedida from "~/fetchs/useMedida";
import useMotivoPerda from "~/fetchs/useMotivoPerda";
import useNivelServico from "~/fetchs/useNivelServico";
import useFunilConcorrentes from "~fetchs/Funnel/useFunilConcorrentes";
import useFunilObraFonteCaptacao from "~fetchs/useFunilObraFonteCaptacao";
import { getFunilOptionsView } from "~services/GlobalServices";

const useFunnelOptions = ({ formikRef }) => {
  const orderOptions = getFunilOptionsView();

  const funilObraGruposProduto = useFunilObraGrupoProduto({ formikRef });
  const { funilObraGrupoProduto } = funilObraGruposProduto;
  const funilObraProdutos = useFunilObraProduto({ formikRef, funilObraGrupoProduto });
  const medidas = useMedida(formikRef);
  const motivosPerda = useMotivoPerda({ formikRef });
  const niveisServico = useNivelServico({ formikRef });
  const funilObraFonteCaptacao = useFunilObraFonteCaptacao({ formikRef });
  const concorrentes = useFunilConcorrentes({formikRef, name: "funilObraConcorrenteId"});

  const contextos = useContexto(formikRef);

  const orders = {
    orderOptions
  };

  const negotiationOptions = [
    { label: "Mais recentes", value: "asc" },
    { label: "Mais antigas", value: "desc" },
  ];

  const negotiations = {
    negotiationOptions
  }

  const status = {
    statusOptions,
  }

  return {
    funilObraFonteCaptacao,
    orders,
    funilObraGruposProduto,
    funilObraProdutos,
    negotiations,
    medidas,
    status,
    motivosPerda,
    niveisServico,
    contextos,
    concorrentes
  }
}

export default useFunnelOptions;

export const statusOptions = [
  { label: "Não Salvo", value: 0 },
  { label: "Na Fila", value: 1 },
  { label: "Em Negociação", value: 2 },
  { label: "Finalizado", value: 3 }
];
